import { Component, Output, EventEmitter, OnDestroy } from "@angular/core";
import { ModalService } from "@services/modal.service";

@Component({
  selector: "app-modal-user-enable-success",
  templateUrl: "./modal-user-enable-success.component.html",
  styleUrls: ["./modal-user-enable-success.component.scss"]
})
export class ModalUserEnableSuccessComponent implements OnDestroy {
  @Output() confirm: EventEmitter<object> = new EventEmitter();
  constructor(public modal: ModalService) {}

  ngOnDestroy() {
    this.modal.close();
  }

  accept() {
    this.confirm.emit();
    this.modal.close();
  }
}
